// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"65040533","453":"fd2c070d","622":"2699f0b9","977":"63d60d97"}[chunkId] + ".chunk.js";
};